import type { InstitutionTheme } from '../types';
import { ucberkeleyColors } from './colors';

// UC Berkeley institutional theme (W56 Worker B, S3).
//
// Brand strings per the fact sheet (admin_tools/backend/data/onboarding/ucberkeley/fact_sheet.yaml):
// official university name and short name (brand.berkeley.edu; the catalog's own display name
// "UC Berkeley Undergraduate Catalog 2026-2027"). Registration portal: CalCentral — named by the
// catalog's own requirement text ("CalCentral under My Academics"); `reported` in the fact sheet for
// registration specifically. Colors per ./colors.ts (Berkeley Blue #002676 + California Gold #FDB515).
//
// Example course codes, each present in the 2026-27 course index (probes/course_index_s0.json):
// COMPSCI 61A (the primary example), MATH 51 (Calculus I — Berkeley renumbered calculus; MATH 1A /
// MATH 1B are NOT in the 2026-27 index), ENGLISH R1A (the Reading & Composition prefix). Deliberately
// not the longest code (AEROENG C136S) — placeholder text should look ordinary.
export const ucberkeleyTheme: InstitutionTheme = {
  slug: 'ucberkeley',
  universityName: 'University of California, Berkeley',
  universityShortName: 'UC Berkeley',
  registrationPortalName: 'CalCentral',
  exampleCourseCodes: ['COMPSCI 61A', 'MATH 51', 'ENGLISH R1A'],
  colors: ucberkeleyColors,
};
